import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
/**
 * Model 更新
 */

var UpdateModelPlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function UpdateModelPlugin() {
    _classCallCheck(this, UpdateModelPlugin);
  }

  _createClass(UpdateModelPlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.beforeRender.tap('UpdateModelPlugin', function () {
        // 处理文本更新
        if (layer.layerModel) {
          layer.layerModel.needUpdate().then(function (flag) {
            if (flag) {
              layer.renderLayers();
            }
          });
        }
      });
      layer.hooks.afterRender.tap('UpdateModelPlugin', function () {
        layer.layerModelNeedUpdate = false;
      });
    }
  }]);

  return UpdateModelPlugin;
}()) || _class);
export { UpdateModelPlugin as default };